__turbopack_context__.v({
  "item": "FiZffG_item",
  "text": "FiZffG_text",
  "withDivider": "FiZffG_withDivider",
});
